import { callWhenIdle } from '@atlassian/jira-call-when-idle';
import { initControlsOnce } from '@atlassian/jira-browser-storage-controls/src/utils/init-once/index.tsx';
import {
	type CookieCircuitBreakerConfig,
	CookieCircuitBreaker,
} from './cookie-circuit-breaker.tsx';
import { didSSRSucceed } from './did-ssr-succeed.tsx';

export function setCircuitBreakerOnIdle({
	isSetCookieEnabled,
	cookieKey,
	windowSize,
	threshold,
	keepOpenCount,
	halfOpenForCount,
}: CookieCircuitBreakerConfig & {
	isSetCookieEnabled: boolean;
}) {
	if (isSetCookieEnabled) {
		callWhenIdle(async () => {
			await initControlsOnce();
			const circuitBreaker = new CookieCircuitBreaker({
				cookieKey,
				windowSize,
				threshold,
				keepOpenCount,
				halfOpenForCount,
			});
			if (didSSRSucceed()) {
				circuitBreaker.recordPass();
			} else {
				circuitBreaker.recordFailure();
			}
		}, 1000);
	}
}
